import {
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { UserData } from '../model/response/user-data';
import { userApi } from '../administration/user-api';

export interface MenuState {
  expanded: boolean;
}

const initialState: MenuState = {
  expanded: true,
};

export const menuSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setExpanded: (
      state: any,
      action: PayloadAction<any>,
    ) => {
      state.expanded = action.payload;
    },
  },
});

export const selectMenu = (state: RootState) => state.menu;
export const { setExpanded } = menuSlice.actions;

export default menuSlice.reducer;
